module.exports = __webpack_public_path__ + "img/bindez-new-logo.110fb21b.png";